import { OPEN_BROADCAST_SUMMARY, CLOSE_BROADCAST_SUMMARY } from "../Modals/ActionTypes";

export const openBroadcastSummaryModal = () => dispatch => {
  dispatch({ type: OPEN_BROADCAST_SUMMARY });
};

export const closeBroadcastSummary = () => dispatch => {
  dispatch({ type: CLOSE_BROADCAST_SUMMARY });
};
